import { lazy, type ComponentType } from "react";
import type { LandingProps } from "@/components/variations/books";
import { DesignShell } from "./design-shell";

const landings: Record<string, ComponentType<LandingProps>> = {
  v1: lazy(() =>
    import("@/components/variations/v1/landing").then((m) => ({
      default: m.V1Landing,
    })),
  ),
  v2: lazy(() =>
    import("@/components/variations/v2/landing").then((m) => ({
      default: m.V2Landing,
    })),
  ),
  v3: lazy(() =>
    import("@/components/variations/v3/landing").then((m) => ({
      default: m.V3Landing,
    })),
  ),
  v4: lazy(() =>
    import("@/components/variations/v4/landing").then((m) => ({
      default: m.V4Landing,
    })),
  ),
  v5: lazy(() =>
    import("@/components/variations/v5/landing").then((m) => ({
      default: m.V5Landing,
    })),
  ),
  v6: lazy(() =>
    import("@/components/variations/v6/landing").then((m) => ({
      default: m.V6Landing,
    })),
  ),
  v7: lazy(() =>
    import("@/components/variations/v7/landing").then((m) => ({
      default: m.V7Landing,
    })),
  ),
  v8: lazy(() =>
    import("@/components/variations/v8/landing").then((m) => ({
      default: m.V8Landing,
    })),
  ),
  v9: lazy(() =>
    import("@/components/variations/v9/landing").then((m) => ({
      default: m.V9Landing,
    })),
  ),
};

export function LandingShell(props: LandingProps) {
  return <DesignShell componentMap={landings} componentProps={props} />;
}
